"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ParagraphText = _interopRequireDefault(require("../../BasicTextElements/ParagraphText"));

var _AmountDue = require("./AmountDue.styles");

var _formatters = require("../../../../helpers/formatters");

var _strings = require("../../../../constants/strings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Price display component
 */
// due to computations in render, chose to go with pureComponent
var AmountDue = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AmountDue, _React$PureComponent);

  var _super = _createSuper(AmountDue);

  function AmountDue() {
    _classCallCheck(this, AmountDue);

    return _super.apply(this, arguments);
  }

  _createClass(AmountDue, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          amount = _this$props.amount,
          amountFollowUp = _this$props.amountFollowUp,
          className = _this$props.className,
          componentSubtext = _this$props.componentSubtext,
          dataTestId = _this$props.dataTestId,
          displayOnlyWholeDollars = _this$props.displayOnlyWholeDollars,
          periodFollowUp = _this$props.periodFollowUp,
          props = _objectWithoutProperties(_this$props, ["amount", "amountFollowUp", "className", "componentSubtext", "dataTestId", "displayOnlyWholeDollars", "periodFollowUp"]);

      return /*#__PURE__*/_react.default.createElement(_AmountDue.StyledAmountDue, _extends({}, props, {
        className: className,
        "data-test-id": dataTestId
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-amount-due-wrapper"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "c-amount-due-amount"
      }, "$", (0, _formatters.formatNumber)(amount, displayOnlyWholeDollars))), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        className: "c-amount-due-subtext",
        dataTestId: "amount-due-subtext"
      }, componentSubtext), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        className: "c-amount-due-follow-up",
        dataTestId: "amount-due-follow-up"
      }, amountFollowUp ? "".concat(_strings.amountDue.followedBy, " $").concat((0, _formatters.formatNumber)(amountFollowUp, displayOnlyWholeDollars)) : '', "\xA0", periodFollowUp));
    }
  }]);

  return AmountDue;
}(_react.default.PureComponent);

_defineProperty(AmountDue, "propTypes", {
  /** Dollar amount to render */
  amount: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Dollar amount to render */
  amountFollowUp: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Text to display under the price */
  componentSubtext: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Display only whole dollars */
  displayOnlyWholeDollars: _propTypes.default.bool,

  /** Text to display after the amount followup */
  periodFollowUp: _propTypes.default.string
});

_defineProperty(AmountDue, "defaultProps", {
  amount: 0,
  amountFollowUp: '',
  className: '',
  componentSubtext: '',
  displayOnlyWholeDollars: false,
  periodFollowUp: ''
});

var _default = AmountDue;
exports.default = _default;